import { Box, ButtonBase, Typography } from "@mui/material";

import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useContext } from "react";
import TreeContext from "./treeContext";

export default function DefaultTreeItem({
  node,
  isExpanded,
  position,
  indentLevel,
}) {
  const { handleToggle, variant } = useContext(TreeContext);
  const fullQuestion = node.title;
  const dom = new DOMParser().parseFromString(fullQuestion, "text/html");
  const title = dom.body.textContent;
  const type = node.type;
  const indentMargin = `${(indentLevel.split(".").length - 2) * 16}px`;

  return (
    <Box display={"flex"} sx={{ gap: 1 }} marginLeft={indentMargin}>
      <ButtonBase
        sx={{
          display: "flex",
          justifyContent: "start",
          gap: 1,
          borderRadius: 1,
          padding: 1,
        }}
        onClick={() => handleToggle(node)}
        disabled={node.items.length === 0}
      >
        <Box textAlign={"left"}>
          <Box display={"flex"} sx={{ gap: 1 }}>
            {node.items.length > 0 ? (
              isExpanded ? (
                <ExpandLessIcon />
              ) : (
                <ChevronRightOutlinedIcon />
              )
            ) : null}
            <Typography variant={variant}>
              {node.title === ""
                ? `${position} ${type} item`
                : `${position} ${title} [${node.label}] - ${type}`}
            </Typography>
          </Box>
        </Box>
      </ButtonBase>
    </Box>
  );
}
